import { cn } from '@/lib/utils'
import localeText from '@/locales/datagrid'
import { Button } from '@/global/components/Button'
import CircularProgress from '@/global/components/CircularProgress'
import { PrinterIcon } from 'lucide-react'
import { useTableApiContext } from '../../utils/table-context'

interface IProps {
    disabled?: boolean
    handleClick: () => void
    isImprimindo: boolean
    sx?: React.CSSProperties
    className?: string
}

export default function ImprimirButton({
    disabled,
    handleClick,
    isImprimindo,
    sx,
    className = '',
}: IProps) {
    const { rows } = useTableApiContext()

    return (
        <Button
            size="small"
            variant="contained"
            onClick={handleClick}
            disabled={isImprimindo || !rows.length || disabled}
            sx={sx}
            title={localeText.toolbarExportPrint}
            className={cn('h-10', className)}
        >
            {isImprimindo ? (
                <CircularProgress color="primary" size={16} />
            ) : (
                <PrinterIcon size={16} />
            )}
            &nbsp;
            <span className="text-[inherit] hidden sm:block">
                {localeText.toolbarExportPrint}
            </span>
        </Button>
    )
}
